import React from 'react'

import { Button, Link } from '@driftt/dds'
import { BarChart, ChartCard } from '@driftt/dds.reports'

import { NON_DATE_BAR_CHART_OPTIONS } from 'constants/meetings'

import useMeetingOutcomes from './useMeetingOutcomes.hook'

const MeetingOutcomesChart = () => {
  const { metric: data, isLoading } = useMeetingOutcomes()

  return (
    <ChartCard>
      <ChartCard.Header
        title="Meeting outcomes"
        subtitle="What are the outcomes of my team's meetings, and what's the breakdown
          by source?"
        action={
          <Link href="/settings2/integrations/detail/salesforce/settings">
            <Button variant="secondary">Manage meeting sync settings</Button>
          </Link>
        }
      />
      <ChartCard.Content>
        <BarChart
          series={data ?? []}
          isLoading={isLoading}
          orientation="column"
          stacking="normal"
          options={NON_DATE_BAR_CHART_OPTIONS}
          tooltipXValueFormat="TITLE_CASE"
        />
      </ChartCard.Content>
    </ChartCard>
  )
}

export default MeetingOutcomesChart
